import { render, staticRenderFns } from "./ContentQuote.vue?vue&type=template&id=68946d98&"
import script from "./ContentQuote.vue?vue&type=script&lang=js&"
export * from "./ContentQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports